import * as React from 'react';

import BaseDateFilter from './shared/base-date-filter';

export function DateFilter({
  label = '',
  useContextFn,
  errorMessages = {},
}: {
  label?: string;
  useContextFn: () => {
    date: Date | null;
    setDate: (value: Date) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { date: value, setDate: onChange } = useContextFn();
  const helperText = errorMessages['date'];
  return (
    <BaseDateFilter
      label={label}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}

export function StartDateFilter({
  label = '',
  useContextFn,
  errorMessages = {},
}: {
  label?: string;
  useContextFn: () => {
    startDate: Date | null;
    setStartDate: (startDate: Date) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { startDate: value, setStartDate: onChange } = useContextFn();
  const helperText = errorMessages['startDate'];
  return (
    <BaseDateFilter
      label={label}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}

export function EndDateFilter({
  label = '',
  useContextFn,
  errorMessages = {},
}: {
  label?: string;
  useContextFn: () => {
    endDate: Date | null;
    setEndDate: (value: Date) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { endDate: value, setEndDate: onChange } = useContextFn();
  const helperText = errorMessages['endDate'];
  return (
    <BaseDateFilter
      label={label}
      value={value}
      onChange={onChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
